import {useHistory, useParams} from "react-router-dom";

import {useCallback, useRef} from "react";
import Main from '../../components/main';
import {FixedTopBar} from '../../components/top_bar';
import ErrorMessage from "../../components/error_message";
import useFeedback from '../../utils/use_feedback';
import {useStoreProfile} from '../../store';
import {useBottomBar} from "../../app_context";
import {useSavedContent} from "../../api/content";
import ContentList from "../../components/content_list";

const SaveFolder = ({title}) => {
    const {folder} = useParams()
    const {expand} = useStoreProfile();
    const {error, feedbackCh} = useFeedback();
    const signalRef = useRef(null);
    const {content, loading, loaded, refresh, loadNextPage, polled} = useSavedContent(feedbackCh, folder, 'Win', signalRef);
    useBottomBar();
    const history = useHistory();
    const openPost = useCallback((post) => {
        history.push(`/p/${post.uuid}`);
    }, [history]);
    return (
        <>
            <FixedTopBar back title={'Saved'} />
            <Main>
                <ErrorMessage error={error}/>
                <ContentList
                    feedKey={`saved/${folder}`}
                    expand={'card'}
                    loading={loading}
                    content={content}
                    refresh={refresh}
                    loadNextPage={loadNextPage}
                    profile
                    onOpenPost={openPost}
                    signalRef={signalRef}
                    polled={polled}
                    noBorders
                />
            </Main>
        </>
    );
};

export default SaveFolder;
